
export default {
  props: {
    checkIn: {
      type: [String, Object],
      default: null,
    },
    checkOut: {
      type: [String, Object],
      default: null,
    },
    time: {
      type: Boolean,
      default: true,
    },
  },
}
